import styled from 'styled-components';

export const HeaderTitle = styled.strong`
  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xs};
  text-transform: uppercase;
`;
